<template>
  <div v-loading.fullscreen="loading" element-loading-text="Saving Data ..." element-loading-spinner="el-icon-loading" class="moow-master-container play-background">
    <nav-basic :progress="10" title="" :btn="false" class="flexy-header"></nav-basic>
    <div class="background-container">
      <div class="map-container-background">
        <gmap-map ref="mymap" :center="mapStartLocation" :zoom="17" style="width: 100%; min-height: 100%">
          <gmap-marker v-if="!loadingPlaceDetails" :position="mapStartLocation"/>
        </gmap-map>
      </div>
      <div class="map-container-background overlay"></div>

    <div class="container">
      <b-row class="step-header">
        <h2></h2>
      </b-row>

      <!-- SEARCH Autocomplete -->
      <!-- <md-card>

        <md-card-content> -->
          <b-row>
            <b-col md="4">
              <a href="#/basic1" style="color:white">Cannot find?</a>
              <md-autocomplete class="moow-input large round play-shadow" v-model="selected"  md-layout="box" :md-options="placesPredictions" @md-changed="getPlacePredictions" @md-selected="getPlaceDetails">
                <label>Where's your place located?</label>

                <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.description }}</template>
              </md-autocomplete>
            </b-col>
          </b-row>

          <b-row :class="{greyedOutContainer:!showPlaceDetails}" class="address-result-container">
            <b-col xl="5" lg="5" md="7" sm="10" cols="10">
              <md-card md-with-hover class="island-card">
                <md-ripple>
                  <md-card-header>
                    <div class="md-title">Confirm location</div>
                    <div class="md-subhead">Add apartment number (optional)</div>
                  </md-card-header>

                  <md-card-content>
                    <p>{{selectedPlace.address.county}} {{selectedPlace.address.municipality}}</p>
                    <p></p>
                    <p>{{selectedPlace.address.street}} {{selectedPlace.address.number}}</p>
                    <span></span>

                    <md-field style="color: #0069d9">
                      <label>Add apartment</label>
                      <md-input v-model="apartmentNumber"></md-input>
                    </md-field>
                  </md-card-content>

                  <md-card-actions >
                    <md-button :disabled="disableNext" v-if="!loadingPlaceDetails" @click="next" style="color: #0069d9">Confirm</md-button>
                    <md-button disabled v-else style="color: #0069d9">searching...</md-button>
                  </md-card-actions>
                </md-ripple>
              </md-card>
            </b-col>
          </b-row>
      </div>
    </div>
  </div>

</template>

<script>
  let emptySelectedPlace = {
    address:{
      county: '',
      municipality: '',
      street: '',
      number: '',
    },
    location: {lat: 59.0000, lng:24.0000}
  }
  import {
    Validator
  } from 'vee-validate'
  import {
    getPlacePredictions,
    getPlaceDetails
  } from '../mapsRepository.js'
  import {
    pullAvailableLocAndBuildDataToSS
  } from '../functions.js'
  let props
  import { convertGoogPlaceDetailsToMoowLocation } from '../utils/address/addressUtil.js'
  export default {
    name: 'adr',
    validator: null,
    data() {
      return {
        loading: false,
        placesPredictions: [],
        selectedPlace: emptySelectedPlace,
        selected: '',
        apartmentNumber: '',
        loadingPlaceDetails: true,
        showPlaceDetails: false,
        disableNext: true,
        mapStartLocation: {lat: 59.436962, lng:24.753574},
      }
    },
    created() {
      if(this.$store.getters.addressVisited == true) this.populateFieldsFromStore()
    },
    methods: {
      populateFieldsFromStore(){
        try{
          var ssLocation = this.$store.getters.location
          ssLocation.address.county?this.selected+=ssLocation.address.county:void 0;
          ssLocation.address.street?this.selected+=", " + ssLocation.address.street:void 0;
          ssLocation.address.number?this.selected+=", " + ssLocation.address.number:void 0;
          this.selectedPlace = ssLocation
          this.mapStartLocation = ssLocation.geoCoords[0]
          this.apartmentNumber = ssLocation.address.apartNumber
          this.showPlaceDetails = true
          this.loadingPlaceDetails = false
          this.disableNext = false
        }catch(err){
          this.notifyError('Sorry, insert address again', 'Didn\'t remember correctly')
        }
      },
      getPlacePredictions(searchTerm){
        try{
          let searhTermForUrl = searchTerm.replace(new RegExp(' ', 'g'), '+');
          this.placesPredictions = getPlacePredictions(searhTermForUrl, 'address')
            .then(predictions => {
              return predictions
            })
            .catch(err => {
              return []
            })
        }catch(error){}
      },
      getPlaceDetails(item){
        this.loadingPlaceDetails = true
        this.showPlaceDetails = true
        this.disableNext = true
        this.selected = item.description
        let placeId = item.place_id
        getPlaceDetails(placeId)
          .then(details => {
            this.selectedPlace = convertGoogPlaceDetailsToMoowLocation(details, placeId)
            this.mapStartLocation = this.selectedPlace.geoCoords[0]
            this.loadingPlaceDetails = false
            this.disableNext = false
          })
          .catch(err => {
            this.loadingPlaceDetails = false
          })
      },
      createBuildingDataRequest(selectedPlace){
        let request = {
          address:{
            county: selectedPlace.address.county,
            municipality: selectedPlace.address.municipality,
            street: selectedPlace.address.street,
            number: selectedPlace.address.number,
            apartNumber: selectedPlace.address.apartNumber
          }
        }
        return request
      },
      leavePage(from, to){
        this.$store.dispatch('visitPage', from);
        this.$router.push({
          name: to
        })
      },
      async next() {
        // if(this.selectedPlace.address.street && this.selectedPlace.address.street != '' && this.selectedPlace.address.number != ''){
        //   this.selectedPlace.address.apartNumber = this.apartmentNumber
        //   let buildingDataRequest = this.createBuildingDataRequest(this.selectedPlace)
        //   pullAvailableLocAndBuildDataToSS(buildingDataRequest)
        //   this.saveAddressPartsToSessionStorage(this.selectedPlace)
        //   this.$store.commit('UPDATE_LOCATION_ENTIRE', this.selectedPlace) //this.$store.getter.location
        //   this.$store.commit('UPDATE_GOOG_LOCATION', this.getGoogLocation(this.selectedPlace))
        //   this.leavePage('ADDRESS', 'basic2')
        // }else{
        //   this.notifyError('Specify location', 'Include street & building')
        // }
          try {
              console.log(this.selectedPlace);
              this.loadingPlaceDetails = true;
              const { address: { street, number: streetNumber, municipality: city } = {} } = this.selectedPlace;
              if (!city || !street || !streetNumber) {
                  this.notifyError('Specify location', 'Include city, street and building');
                  return;
              }
              // TODO: extract to a separate method?
              try {
                  const propertyAlreadyExists = await this.$store.dispatch('checkPropertyAddress', {
                      city,
                      street,
                      streetNumber,
                      apartmentNumber: this.apartmentNumber || null,
                  });
                  if (propertyAlreadyExists) {
                      this.notifyError('Property address check', 'Property with chosen address already exists');
                      return;
                  }
              }
              catch (error) {
                  this.notifyError('Property address check error', 'Cannot check property address at the moment');
                  console.error(error);
                  return;
              }

              this.selectedPlace.address.apartNumber = this.apartmentNumber;
              let buildingDataRequest = this.createBuildingDataRequest(this.selectedPlace);
              pullAvailableLocAndBuildDataToSS(buildingDataRequest);
              this.saveAddressPartsToSessionStorage(this.selectedPlace);
              this.$store.commit('UPDATE_LOCATION_ENTIRE', this.selectedPlace); //this.$store.getter.location
              this.$store.commit('UPDATE_GOOG_LOCATION', this.getGoogLocation(this.selectedPlace));
              this.leavePage('ADDRESS', 'basic2');
          }
          catch (error) {
              this.notifyError('Property location error', 'Cannot determine property location at the moment');
          }
          finally {
              this.loadingPlaceDetails = false;
          }
      },
      prev() {
        this.leavePage('ADDRESS', 'addListing1')
      },
      navigate(evt) {
        evt.preventDefault();
      },
      getGoogLocation(selectedPlace){
        let muni = this.getMuniWithoutExtras(selectedPlace.address.municipality)
        return{
          aal1: selectedPlace.address.county,
          locality: muni,
          placeId: selectedPlace.placeId,
          geoCoords: selectedPlace.geoCoords
        }
      },
      getMuniWithoutExtras(municipality){
        let muni = municipality
        try{
          let indexOfVald = municipality.toLowerCase().indexOf('vald')
          if(indexOfVald !== -1) muni = muni.substring(-1, indexOfVald).trim();
          return muni
        }catch(err){}
        return municipality
      },
      saveAddressPartsToSessionStorage(finalAddress){
        sessionStorage.setItem('country', finalAddress.address.country)
        sessionStorage.setItem('county', finalAddress.address.county)
        sessionStorage.setItem('street',finalAddress.address.street)
        sessionStorage.setItem('number',finalAddress.address.number)
        sessionStorage.setItem('apartNumber', finalAddress.address.apartNumber)
        sessionStorage.setItem('latitude',finalAddress.geoCoords[0].lat)
        sessionStorage.setItem('longitude',finalAddress.geoCoords[0].lng)
      },
      notifyError(title, msg){
        this.$notify({
          title: title,
          message: msg
        })
      },
    }
  }

</script>

<style scoped>
  @import '../assets/styles/global.css';
  @import '../assets/styles/add-steps.css';
  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  .md-autocomplete {
    background-color: white;
    opacity: 1;
  }



  .background-container{
    display: flex;
    flex-flow: column;
    height: 100%;
  }

  .map-container-background{
    height: 100%;
    position: absolute;
    width: 100%;
  }
  .map-container-background.overlay{
    background-color: #383838;
    opacity: 0.2;
  }

</style>



// WEBPACK FOOTER //
// src/components/address.vue